












































































import { Component, Vue } from "vue-property-decorator";
import { Validate } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { SPACE_TYPE } from "@/resources/constants/space";
import ModalSelectSceneComponent from "@/app/components/manageSpace/components/space/customizeSpace/modalSelectScene.component.vue";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
@Component({
  name: "new-space-component",
  components: { ModalSelectSceneComponent },
})
export default class NewSpaceComponent extends mixins(NotificationEvent) {
  @Validate({ required })
  spaceName = "";
  @Validate({ required, email })
  creatorEmail = "";
  spaceTypes = Object.values(SPACE_TYPE);
  spaceType = SPACE_TYPE.OFFICE_TYPE;
  loading = false;
  openModal = false;
  scene = null;
  mounted() {
    this.getScenes();
  }
  get active() {
    return this.$store.getters["AdminStore/getOpenNewSpaceModal"];
  }
  set active(e) {
    this.$store.dispatch("AdminStore/setOpenNewSpaceModalAction", e);
  }
  getScenes() {
    let space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SpaceStore/getSceneTypesAction", {
      spaceType: this.spaceType,
      superSpaceId: space.superSpace.id,
      callback: (scene) => {
        this.scene = scene;
      },
    });
  }
  selectScene(e) {
    this.scene = e;
  }
  onSave() {
    this.loading = true;
    this.$store.dispatch("SpaceStore/createSpaceAction", {
      data: {
        name: this.spaceName,
        type: this.spaceType,
        scenarioType: this.scene.id,
        createdByUserEmail: this.creatorEmail,
      },
      callback: () => {
        this.loading = false;
        this.active = false;
        this.spaceName = "";
        this.creatorEmail = "";
        this.$router.go(-1);
        this.onSuccess(
          this.$i18n.t("notifications.titles.success"),
          this.$i18n.t("notifications.descriptions.createSpace")
        );
      },
    });
  }
}
